import BaseComponent from '/webresources-sources/js/components/base-component';
import { urlQuery } from '/webresources-sources/js/util/url';
import { defineComponent } from '/webresources-sources/js/util/jquery';

// TODO: this is a modified copy of sraysono-magnolia-categories/templates/components/pages-overview/pages-overview-component.js
export default class PagesOverviewComponent extends BaseComponent {
    properties() {
        return {
            selectedCategories: [],
            filteredCategories: {},
            url: '',
            contentPath: '',
            currentPage: 0,
            previousPageIndex: -1,
            seed: '',
        };
    }

    connected() {
        this.previousPageIndex = this.currentPage - 1;
        this.updateUrl();
    }

    afterUpdate() {
        /** @type PageCount */
        const pageCount = this.element.querySelector('page-count');
        if (pageCount) {
            pageCount.currentPage = this.currentPage;
            pageCount.previousPageIndex = this.previousPageIndex;
        }

        this.updateUrl();
    }

    watch() {
        return {
            selectedCategories: (selectedCategories) => {
                //console.log('selectedCategories',selectedCategories);
                const clearFilterButton = this.element.querySelector('[data-clear-filter=""]');

                if (!clearFilterButton) return;

                if (selectedCategories && selectedCategories.length > 0) {
                    clearFilterButton.classList.remove('d-none');
                } else {
                    clearFilterButton.classList.add('d-none');
                }
            },
        };
    }

    events() {
        return {
            this: {
                'init-categories': (e) => {
                    //console.log('init-categories', e.detail);
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                },
                'select-categories': (e) => {
                    //console.log('select-categories', e.detail);
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                    this.currentPage = 0;
                    this.seed = new Date().getTime();

                    this.dispatch('loading-start');
                    this.fetchPages().then((html) => {
                        this.dispatch('loading-end');
                        const container = this.element.querySelector('.pages');
                        $(container).html($(html).find('.page-count,.previous-page,.page,.next-page'));
                        this.registerEvents();
                    });
                },
            },
            '[load-previous-page]': {
                click: (e) => {
                    e.preventDefault();
                    const previousPageIndex = parseInt(e.target.getAttribute('load-previous-page'));

                    this.fetchPages(previousPageIndex).then((html) => {
                        this.previousPageIndex--;
                        const container = this.element.querySelector('.previous-page');
                        $(container).replaceWith($(html).find('.previous-page,.page'));
                        this.registerEvents();
                    });
                },
            },
            '[load-next-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.currentPage = parseInt(e.target.getAttribute('load-next-page'));

                    this.fetchPages(this.currentPage).then((html) => {
                        const container = this.element.querySelector('.next-page');
                        $(container).replaceWith($(html).find('.page,.next-page'));
                        this.registerEvents();
                    });
                },
            },
            '[data-page]': {
                click: (e) => {
                    const pageContainer = e.target.closest('[data-page]');
                    if (e.target.nodeName === 'A' && pageContainer) {
                        this.currentPage = parseInt(pageContainer.dataset.page);
                    }
                },
            },
        };
    }

    get urlParameters() {
        return {
            regions: this.filteredCategories['regions']?.length > 0 ? this.filteredCategories['regions'] : undefined,
            categories: this.filteredCategories['categories']?.length > 0 ? this.filteredCategories['categories'] : undefined,
            currentPage: this.currentPage > 0 ? this.currentPage : undefined,
            seed: this.seed && this.seed !== '' ? this.seed : undefined,
        };
    }

    fetchPages(currentPage = this.currentPage) {
        const urlParameters = { ...this.urlParameters, currentPage };
        return fetch(`${this.contentPath}?${urlQuery(urlParameters)}`).then((result) => result.text());
    }

    updateUrl() {
        const query = urlQuery(this.urlParameters, true);
        history.replaceState(this.urlParameters, '', query ? `?${query}` : location.pathname);
    }
}

defineComponent('by-tm-pages-overview-component', PagesOverviewComponent);
